import { IDP_PROVIDER } from "./idpProviders";

/**
 * Best-effort provider inference from OIDC issuer URL (legacy API compatibility).
 * @param {string | null | undefined} issuer
 * @returns {import('./idpProviders').IdpProviderId}
 */
export function inferProviderFromIssuer(issuer) {
  const value = String(issuer || "").toLowerCase();

  if (!value) {
    return IDP_PROVIDER.GENERIC_OIDC;
  }

  if (
    value.includes("login.microsoftonline.com") ||
    value.includes("sts.windows.net")
  ) {
    return IDP_PROVIDER.MICROSOFT_ENTRA;
  }
  if (
    value.includes("accounts.google.com") ||
    value.includes("googleusercontent.com")
  ) {
    return IDP_PROVIDER.GOOGLE;
  }
  if (value.includes("okta.com") || value.includes("oktapreview.com")) {
    return IDP_PROVIDER.OKTA;
  }
  if (value.includes("auth0.com")) {
    return IDP_PROVIDER.AUTH0;
  }
  if (value.includes("pingidentity") || value.includes("pingone")) {
    return IDP_PROVIDER.PING;
  }
  if (value.includes("keycloak")) {
    return IDP_PROVIDER.KEYCLOAK;
  }
  if (value.includes("onelogin.com")) {
    return IDP_PROVIDER.ONELOGIN;
  }
  if (value.includes("jumpcloud.com")) {
    return IDP_PROVIDER.JUMPCLOUD;
  }
  if (value.includes("forgerock")) {
    return IDP_PROVIDER.FORGEROCK;
  }
  if (value.includes("verify.ibm.com") || value.includes("iam.cloud.ibm.com")) {
    return IDP_PROVIDER.IBM_VERIFY;
  }
  if (value.includes("identity.oraclecloud.com") || value.includes("idcs")) {
    return IDP_PROVIDER.ORACLE_IDCS;
  }
  if (value.includes("salesforce.com") || value.includes("force.com")) {
    return IDP_PROVIDER.SALESFORCE;
  }
  if (value.includes("cognito") || value.includes("amazoncognito.com")) {
    return IDP_PROVIDER.AWS_COGNITO;
  }
  if (value.includes("duosecurity.com") || value.includes("duo.com")) {
    return IDP_PROVIDER.DUO;
  }
  if (value.includes("sap.com") || value.includes("accounts.ondemand.com")) {
    return IDP_PROVIDER.SAP_IAS;
  }

  return IDP_PROVIDER.GENERIC_OIDC;
}
